<nav class="navbar">
  <div class="wrapper">
    <app-image
      class="logo"
      img="/images/logo-vanti.png"
      alt="Vanti Logo"
    ></app-image>
    <div class="sessionInfo">
      <p class="userName">
        Bienvenido: <b>{{ userName }}</b>
      </p>
      <app-button
        class="button"
        label="Cerrar sesion"
        variant="primary"
        (onClick)="handleLogout()"
      />
    </div>
  </div>
  <ul class="menu">
    @for (item of menu; track $index) {
      <li class="optionMenu" [class.active]="isActive(item.label)">
        <a [routerLink]="item.route" (click)="onNavigate()">{{ item.label }}</a>
        @if (item.children) {
          <ul class="submenu">
            @for (sub of item.children; track $index) {
              <li class="optionSubMenu">
                <a [routerLink]="sub.route" (click)="onNavigate()">{{
                  sub.label
                }}</a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</nav>
